export const SIDEBAR_LOCALE_ZHCHT = {
    sidebar: 'è©³æ',
};
